export default __webpack_public_path__ + "static/media/bin.c6fe4c6a.svg";